module.exports = __webpack_public_path__ + "static/media/multi_location.a20a69df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/multi_location.svg
// module id = 405
// module chunks = 0